import * as React from 'react'
import { PrismicPreviewProvider } from 'gatsby-plugin-prismic-previews'

import './src/components/layout.css'
import { linkResolver } from './src/utils/linkResolver'

import PageTemplate from './src/templates/page-template'

export const wrapRootElement = ({ element }) => (
  <PrismicPreviewProvider
    repositoryConfigs={[
      {
        repositoryName: process.env.GATSBY_PRISMIC_REPO_NAME,
        linkResolver,
        componentResolver: {
          page: PageTemplate,
        },
      },
    ]}
  >
    {element}
  </PrismicPreviewProvider>
)
